import { rehydrateToken } from 'utils/token';

function handleDownload(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);

    Error.captureStackTrace(this, ApiError);

    this.status = status;
    this.message = message;
  }
}

type ResponseType = 'json' | 'blob';

const handleResponse = (response: Response, responseType: ResponseType | null, fileName?: string) => {
  if (!response.ok) {
    throw new ApiError(response.statusText, response.status);
  }

  switch (responseType) {
    case 'json':
      return response.json();
    case 'blob':
      return response.blob().then((blob) => {
        handleDownload(blob, fileName as string);
      });
    default:
      return response;
  }
};

export const get = (
  url: string,
  headers: Record<string, string> = {},
  responseType: ResponseType | null = 'json',
  fileName?: string,
) => {
  return fetch(url, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      'x-mixmode-api-token': rehydrateToken() as string,
      ...headers,
    }),
  }).then((response) => handleResponse(response, responseType, fileName));
};

export const post = (
  url: string,
  data: unknown,
  headers: Record<string, string> = {},
  responseType: ResponseType | null = 'json',
  fileName?: string,
) => {
  return fetch(url, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      'x-mixmode-api-token': rehydrateToken() as string,
      ...headers,
    }),
    body: JSON.stringify(data),
  }).then((response) => handleResponse(response, responseType, fileName));
};

export const head = (url: string, headers: Record<string, string> = {}) => {
  return fetch(url, {
    method: 'HEAD',
    headers: new Headers({
      'Content-Type': 'application/json',
      'x-mixmode-api-token': rehydrateToken() as string,
      ...headers,
    }),
  }).then((response) => handleResponse(response, null));
};
